import HolidaysYearsList from "../../../../component/holidays/holiday-list/HolidaysYearsList";

export default function HolidaysYears() {
  return (
    <div className="page-body">
      <HolidaysYearsList />
    </div>
  );
}
